import Api from '../../../Api'
import createTableFetcher from 'common/reducer/createTableFetcher'

const selector = state => {
    return state.waas.expiredApps
}

const tableFetcher = createTableFetcher('EXPIRED_APPS', Api.getExpiredAccounts, selector)

export const actions= tableFetcher.actions
export const reducer = tableFetcher.reducer
export const saga = tableFetcher.saga
